module.exports = __webpack_public_path__ + "logo-jenv-justis.svg?55e34f7ff8c21bd5a31902bf26e7792e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-jenv-justis.svg
// module id = 709
// module chunks = 0